import './KitchenPage.scss'
import {useState} from "react";
import FridgePage from "../FridgePage/FridgePage";
import notification from "../../sounds/notification.mp3";
import {t} from "i18next";

const KitchenPage = (props) => {
  const {
    onChangeView,
    currentTime,
    soundsFX,
    soundsRef,
  } = props

  const onHoverNotif = () => {
    soundsFX.onPlay(notification, false,false, soundsRef)
  }

  const dayNightSwitcher = ((currentTime >= 6 && currentTime < 12) || (currentTime >= 18 && currentTime < 23)) ? "06" :
    currentTime >= 12 && currentTime < 18 ? "12" : '00'

  return <div className="KitchenPage">


    <button className="fridge" onClick={()=>{onChangeView("FridgePage")}} ></button>
    <div className="desck">
      <div className="note2" onMouseEnter={()=>onHoverNotif()}><div className="tooltip">{t('kp-note')}</div></div>
      <div className="note3" onMouseEnter={()=>onHoverNotif()}><div className="tooltip">{t('kp-note2')}</div></div>
      <div className="note" onMouseEnter={()=>onHoverNotif()}><div className="tooltip">{t('kp-note3')}</div></div>
      <div className="note4" onMouseEnter={()=>onHoverNotif()}><div className="tooltip">{t('kp-note4')}</div></div>
    </div>
    <div className="bucket" />

    <button className="pc" onClick={()=>{onChangeView("PCScreenPage")}} > </button>
    <button className="bedroom" onClick={()=>{onChangeView("BedroomPage")}} > {t('kp-Bedroom')} </button>
    <div className={`window-${dayNightSwitcher}`}></div>
  </div>
}

export default KitchenPage